<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<div class="container">
			<div class="fixation">
				<div class="filtrate">
					<div class="block" v-for="(item,index) in filtrate" :key="index" :style="height">
						<div class="blockTitle">
							{{item.name}}
						</div>
						<div class="blockBox">
							<div class="blockItem" v-for="(tab,tabIndex) in item['tab']" :key="tabIndex">
								{{tab.name}}({{tab.number}})
							</div>
						</div>
						<div class="blockMore">
							<!-- <div class="moreBtn">
								更多
								<i class="el-icon-arrow-down"></i>
							</div> -->
						</div>
					</div>
				</div>
				<div class="commodity">
					<commodityList ref="refresh" v-bind:commodity="commodity" v-bind:type='"score"'></commodityList>
				</div>
				<div class="pager">
					<el-pagination background layout="prev, pager, next" :page-size="limit" :current-page="page" :total="totalPage*limit" @size-change="clickPage" @prev-click="prevPage" @next-click="nextPage"></el-pagination>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	// your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	import commodityList from '../../components/commodityList.vue'
	export default {
		name: 'score',
		components:{
			Head,Foot,commodityList
		},
		data(){
			return {
				filtrate:[],
				height:"max-height:60px",
				commodity:[],
				limit:25,
				page:1,
				totalPage:1
			}
		},
		methods:{
			fetchData(){
				var data = {
					method:"IntegralShop.positionIntegraslShop",
					page:this.page,
					limit:this.limit
				}
				var that = this
				this.request(data,(res)=>{
					console.log(res)
					if(res.status){
						var brand = res.data.brand
						var cat = res.data.cat
						var obj = {
							"name":"品牌",
							"id":"1",
							"tab":brand
						}
						var obj2 = {
							"name":"分类",
							"id":"2",
							"tab":cat
						}
						that.filtrate.push(obj)
						that.filtrate.push(obj2)
						console.log(that.filtrate)
						var list = res.data.list
						for (var i = 0; i < list.length; i++) {
							var item = list[i]
							var obj = {
								"avatar":item.image_url,
								"price":item.integral_price,
								"sale":'0.00',
								"name":item.name,
								"id":item.id
							}
							that.commodity.push(obj)
						}
						that.$refs.refresh.setData()
						that.totalPage = res.data.total_page
					}else{
						that.globalTest('IntegralShop.positionIntegraslShop','error',res.msg,res.data)
					}
				})
			},
			clickPage(page){
				this.page = page
				this.commodity = []
				this.fetchData()
			},
			prevPage(e){
				this.page = e
			},
			nextPage(e){
				this.page = e
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.tid = this.$route.query.tid
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.filtrate{
		width: 100%;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
		padding: 10px 9px;
		margin-top: 10px;
	}
	.block{
		width: 100%;
		border-bottom: 1px solid #D3D3D3;
		line-height: 30px;
		position: relative;
		overflow: hidden;
	}
	.block:last-child{
		border-bottom: none;
	}
	.blockTitle{
		width: 150px;
		height: 30px;
		position: absolute;
		left: 0px;
		top: 0px;
	}
	.blockBox{
		width: 100%;
		height: 100%;
		padding-left: 150px;
		padding-right: 100px;
		box-sizing: border-box;
		font-size: 0px;
		letter-spacing: -6px;
	}
	.blockItem{
		max-width: 200px;
		height: 30px;
		display: inline-block;
		vertical-align: top;
		padding: 0px 10px;
		box-sizing: border-box;
		font-size: 12px;
		letter-spacing: normal;
		overflow: hidden;
		color: #838383;
	}
	.blockItem:hover{
		color: #036DEE;
	}
	.blockMore{
		width: 100px;
		height: 30px;
		position: absolute;
		right: 0px;
		top: 0px;
	}
	.moreBtn{
		width: 80px;
		height: 24px;
		border: 1px solid #C3C3C3;
		text-align: center;
		box-sizing: border-box;
		line-height: 22px;
		margin: 3px auto;
		font-size: 12px;
		color: #333333;
		cursor: pointer;
	}
	.moreBtn:hover{
		color: #036DEE;
		border: 1px solid #036DEE;
	}
	.order{
		width: 100%;
		height: 50px;
		border: 1px solid #D3D3D3;
		margin-top: 30px;
		line-height: 50px;
		text-align: center;
		background: -webkit-linear-gradient(#F3F3F3, #F0F0F0); /* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(#F3F3F3, #F0F0F0); /* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(#F3F3F3, #F0F0F0); /* Firefox 3.6 - 15 */
		background: linear-gradient(#F3F3F3, #F0F0F0); /* 标准的语法 */
	}
	.default,.sales,.price{
		width: 100px;
		height: 100%;
		float: left;
	}
	.pager{
		width: 100%;
		height: 50px;
		margin-top: 30px;
	}
</style>
